export default "__VITE_ASSET__SnGQr9Kn__ 100w";